<div class="flex-row align-items-center">
    <a  class="logo" [routerLink]="['']">
        <img class="logo-img" src="assets/layout/images/logo.png">
    </a>
    <span *ngIf="app.toolbarBackButton">
        <a class="icon" href="javascript:history.back()">
            <i class="fas fa-arrow-left"></i>
        </a>
    </span>

    <p-breadcrumb *ngIf="app.breadcrumbsVisible && app.breadcrumbsInToolBar" class="breadcrumbs" [home]="app.breadcrumbsHome" [model]="app.breadcrumbsItems"></p-breadcrumb>
    <div *ngIf="app.staticHeaderHtml != null" class="ml-5" [innerHTML]="app.staticHeaderHtml"></div>
</div>
<div class="burger-menu mr-3 flex-row align-items-center color-primaryText">
    @if (app.multilingual) {
        <p-avatar styleClass="color-primaryText ml-2 mr-3 mouse-pointer" size="normal" shape="circle" (click)="languageClicked()">
            <img src="{{_RestEndpoint.getUrl()}}/api/app/flag?language={{app.language}}">
        </p-avatar>
    }
    <i class="fas fa-bars mouse-pointer" (click)="menuButtonClick()"></i>
</div>
<div class="desktop-menu flex-row fadeInDown align-items-center">
    @if (app.toolbarHomeButton) {
        <a class="topbar-icon color-primaryText" href=# [routerLink]="['/enaio-learn', 'home']">
            <i class="fas fa-home"></i>
        </a>
    }
    @if (app.toolbarNotificationsButton) {
        <a class="topbar-icon color-primaryText" href="#" [routerLink]="['/enaio-learn', 'notifications']">
            <i class="fas fa-bell"></i>
            <span *ngIf="app.unreadNotificationCount > 0" class="topbar-badge">{{app.unreadNotificationCount}}</span>
        </a>
    }
    @if (app.toolbarHelpButton) {
        <i class="topbar-icon color-primaryText mouse-pointer" (click)="helpClicked($event)">
            <i class="fas fa-circle-question"></i>
        </i>
    }
    @for (button of app.toolbarButtons; track button) {
        @if (button.visible) {
            <a class="topbar-icon color-primaryText" href="#" [routerLink]="button.routerLink" (click)="buttonClick(button)">
                <i [ngClass]="button.icon"></i>
            </a>
        }
    }
    @if (app.multilingual) {
        <p-avatar class="lang-icon" styleClass="color-primaryText ml-1 mr-2 mouse-pointer" size="normal" shape="circle" (click)="languageClicked()">
            <img src="{{_RestEndpoint.getUrl()}}/api/app/flag?language={{app.language}}">
        </p-avatar>
    }
    @if (app.toolbarShowUser) {
        <div class="mouse-pointer" (click)="menuButtonClick()">
            <p-avatar [label]="getUserNameShort()" styleClass="color-primaryText ml-2 mr-3" size="large" shape="circle"></p-avatar>
            <span class="color-primaryText mr-3">{{getUserName()}}</span>
        </div>
    }
</div>
